import Icon from "@material-ui/core/Icon"
import { FC } from "react"
import { NotificationKind } from "../../containers/notificationSlice"

interface IAlertBox {
  type: NotificationKind
  message: string | JSX.Element
  className?: string
  onClose?: () => void
}

const AlertBox: FC<IAlertBox> = ({ message, onClose, className, type }) => {
  const getClassName = () => {
    switch (type) {
      case NotificationKind.ERROR:
        return "ocs-notification-error"
      case NotificationKind.WARNING:
        return "ocs-notification-warning"
      case NotificationKind.INFO:
        return "ocs-notification-info"
      case NotificationKind.SUCCESS:
        return "ocs-notification-success"
      default:
        return "ocs-notification-info"
    }
  }

  const getIcon = () => {
    switch (type) {
      case NotificationKind.ERROR:
        return "close"
      case NotificationKind.WARNING:
        return "priority_high"
      case NotificationKind.INFO:
        return "priority_high"
      case NotificationKind.SUCCESS:
        return "check"
      default:
        return "ocs-notification-info"
    }
  }

  return (
    <section
      className={`alert-content ocs-notification d-flex align-items-center ${getClassName()} ${className}`}
    >
      <div className="alert-icon">
        <Icon className="ocs-md-btn-icon">{getIcon()}</Icon>
      </div>

      <div>
        <header className="alert-header d-flex justify-content-between">
          <h2 className="alert-heading">{type}</h2>
        </header>
        <p className="alert-text">{message}</p>
      </div>

      {onClose && (
        <button
          className="material-icons ocs-icon-btn alert-close"
          onClick={onClose}
        >
          close
        </button>
      )}
    </section>
  )
}

export default AlertBox
